//#region Util Imports

import * as $ from 'jquery'

//#endregion

import { Enums } from '../common/enums'
import { DataProvider } from '../../helpers/data-provider'
import { IOpChangeState, IReferenceType, IJsonSerializable } from '../util/interfaces'

export class OpDataTypeGroup implements IReferenceType, IOpChangeState, IJsonSerializable {
    public idDataTypeGroup: number
    public idDataTypeGroupType: number
    public idParentGroup: number
    public idReferenceType: number
    public referenceValue: any
    public name: string

    constructor(opObj: any) {
        this.fromJSON(opObj)
    }

    //IOpChangeState implementation
    public opState: Enums.OpChangeState
    //IOpChangeState implementation end
    //IReferenceType implementation
    public getReferenceType(): Enums.ReferenceType {
        return Enums.ReferenceType.IdDataTypeGroup
    }
    public getReferenceKey(): number {
        return this.idDataTypeGroup
    }
    public getReferenceValue(): any {
        return this
    }
    //IReferenceType implementation end

    
    public fromJSON(opObj: any, compressed: boolean = false): void {
        if (opObj) {

            if (compressed || (opObj && opObj.__IC && opObj.__IC == 1)) {

                this.idDataTypeGroup = opObj.I
                this.idDataTypeGroupType = opObj.ID
                this.idParentGroup = opObj.IP
                this.idReferenceType = opObj.IR
                this.referenceValue = opObj.R
                this.name = opObj.N
                this.opState = opObj.O

            } else {

                this.idDataTypeGroup = opObj.ID_DATA_TYPE_GROUP
                this.idDataTypeGroupType = opObj.ID_DATA_TYPE_GROUP_TYPE
                this.idParentGroup = opObj.ID_PARENT_GROUP
                this.idReferenceType = opObj.ID_REFERENCE_TYPE
                this.referenceValue = opObj.REFERENCE_VALUE
                this.name = opObj.NAME
                this.opState = opObj.OpState

            }
        }
    }

    public toJSON(compressed: boolean = false): any {

        if (compressed) {
            return {

                I: this.idDataTypeGroup,
                ID: this.idDataTypeGroupType,
                IP: this.idParentGroup,
                IR: this.idReferenceType,
                R: this.referenceValue,
                N: this.name,
                O: this.opState,

                __IC: 1

            }
        } else {
            return {
                ID_DATA_TYPE_GROUP: this.idDataTypeGroup,
                ID_DATA_TYPE_GROUP_TYPE: this.idDataTypeGroupType,
                ID_PARENT_GROUP: this.idParentGroup,
                ID_REFERENCE_TYPE: this.idReferenceType,
                REFERENCE_VALUE: this.referenceValue,
                NAME: this.name,
                OpState: this.opState
            }
        }
    }

    public toString() {
        return this.name
    }

    public static loadNavigationProperties(dataProvider: DataProvider, list: OpDataTypeGroup[]): JQueryPromise<OpDataTypeGroup[]> {
        var defered = $.Deferred<OpDataTypeGroup[]>()
        if (dataProvider && list && list.length > 0) {
            defered.resolve(list)
        } else {
            defered.resolve(list)
        }
        return defered.promise()
    }
}